import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useSetTwitchMembershipsDiscountStatusMutation = createMutationHook(
  MembershipsCreatorApiClient.setTwitchDiscountStatus,
  {
    mutationKey: ['setTwitchMembershipsDiscountStats'],
  },
)
